import React from "react";
import { Divider, Spin, Progress } from "antd";
import LineChart from "./LineChart";
import IntlMessages from "../../util/IntlMessages";
import { setCommonConfigs, StringIsNullOrEmpty } from "../../appRedux/actions";
import { HOME } from "../../constants/Pages";
import BEHAVIOUR_TYPE from "../../Services/DataServices";
import ds from "../../Services/DataServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getRandomInt, formatDigits } from "../../appRedux/actions";
import { useHistory } from "react-router";
import { Line } from "recharts";
import { Period } from "../../constants/Period";

const PerformanceCardSection = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const SectionID = props && props.sectionID ? parseInt(props.sectionID) : 1;
  const PeriodID =
    props && props.periodID ? parseInt(props.periodID) : Period.Day;
  const OutletID = props && props.outletID ? parseInt(props.outletID) : 0;
  const chartTitle = props && props.chartTitle ? props.chartTitle : "";
  const showProgressSection =
    props && props.showProgressSection ? props.showProgressSection : false;
  const cardTitle = props && props.cardTitle ? props.cardTitle : "";
  const isCurrencyMeasure =
    props && props.isCurrencyMeasure ? props.isCurrencyMeasure : "";
  const MeasureID = props && props.measureID ? parseInt(props.measureID) : 0;
  const ReportTypeID = props && props.reportTypeID ? props.reportTypeID : "";
  const design = props && props.design ? props.design : "";
  const subHeading1 = props && props.subHeading1 ? props.subHeading1 : "";
  const subHeading2 = props && props.subHeading2 ? props.subHeading2 : "";
  const parentClassName = props && props.parentClassName ? props.parentClassName : "";
  

  //#region Use Selector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );

  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  //#endregion Use Selector

  //#region UseState
  const [getPeriodName, setPeriodName] = React.useState("");
  const [getReportSectionData, setReportSectionData] = React.useState({
    TotalValue1: 0,
    PreviousValue1: 0,
    TotalValue2: 0,
    PreviousValue2: 0,
    AverageSaleValue: 0,
    AverageSaleValuePrev: 0,
    AverageItemPerSaleValue: 0,
    AverageItemPerSaleValuePrev: 0,
    LineChartsData: [],
  });
  const [getCurrData, setCurrData] = React.useState({
    currencyCode: "",
    currencyName: "",
    currencySymbol: "",
  });
  const [getLoader, setLoader] = React.useState(true);

  const [getChartInterval, setChartInterval] = React.useState(1);

  //#endregion UseState

  //#region UseEffect
  React.useEffect(() => {
    let mounted = true;

    const body = {
      PeriodId: PeriodID,
      OutletId: OutletID,
      SectionId: SectionID,
      MeasureId: MeasureID,
    };
    getBIDashboardReports(body);
    return () => (mounted = false);
  }, [PeriodID, OutletID]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);
  //#endregion

  //#region API

  async function getBIDashboardReports(body) {
    setLoader(true);

    if (PeriodID == Period.Day) {
      setPeriodName("Day");
    }
    if (PeriodID == Period.Week) {
      setPeriodName("Week");
    }
    if (PeriodID == Period.Month) {
      setPeriodName("Month");
    }
    const getReports = ds.getBIDashboardReportsService(
      body,
      BEHAVIOUR_TYPE.POST
    );
    await getReports
      .then((res) => {
        if (res) {
          let lineChartsData = [];

          let totalValue1 = "0";
          let previousValue1 = "0";
          let totalValue2 = "0";
          let previousValue2 = "0";
          if(MeasureID ==19){
          }

          try {
            let currentValueInfoParse = JSON.parse(res.data.currentValueInfo);
            let currentValueInfoObj = Object.keys(currentValueInfoParse[0]).map(
              (key) => [key, currentValueInfoParse[0][key]]
            );
             
            if (
              currentValueInfoObj &&
              currentValueInfoObj != null &&
              currentValueInfoObj.length > 0
            ) {
              
              totalValue1 =
                currentValueInfoObj[1] != null &&
                currentValueInfoObj[1] != undefined &&
                currentValueInfoObj[1].length > 0
                  ? currentValueInfoObj[1][1] != null
                    ? currentValueInfoObj[1][1]
                    : "0"
                  : "0";
              previousValue1 =
                currentValueInfoObj[2] != null &&
                currentValueInfoObj[2] != undefined &&
                currentValueInfoObj[2].length > 0
                  ? currentValueInfoObj[2][1] != null
                    ? currentValueInfoObj[2][1]
                    : "0"
                  : "0";
              totalValue2 =
                currentValueInfoObj[3] != null &&
                currentValueInfoObj[3] != undefined &&
                currentValueInfoObj[3].length > 0
                  ? currentValueInfoObj[3][1] != null
                    ? currentValueInfoObj[3][1]
                    : "0"
                  : "0";

              previousValue2 =
                currentValueInfoObj[4] != null &&
                currentValueInfoObj[4] != undefined &&
                currentValueInfoObj[4].length > 0
                  ? currentValueInfoObj[4][1] != null
                    ? currentValueInfoObj[4][1]
                    : "0"
                  : "0";

              //console.log("Revenue Total", totalValue1);
             // console.log("Revenue Previous", previousValue1);
            }
          } catch (e) {
            // message.error("Revenue Total Count Parsing Issue");
            totalValue1 = "0";
            previousValue1 = "0";
            totalValue2 = "0";
            previousValue2 = "0";
          }

          let averageSaleTotal = "0";
          let averageSalePrevious = "0";
          let averageItemPerSaleTotal = "0";
          let averageItemPerSalePrevious = "0";

          try {
            let measureInfoParse = JSON.parse(res.data.measureInfo);
            let measureInfoObj = Object.keys(measureInfoParse[0]).map((key) => [
              key,
              measureInfoParse[0][key],
            ]);
            if (
              measureInfoObj &&
              measureInfoObj != null &&
              measureInfoObj.length > 0
            ) {
              averageSaleTotal =
                measureInfoObj[1] != null &&
                measureInfoObj[1] != undefined &&
                measureInfoObj[1].length > 0
                  ? measureInfoObj[1][1] != null
                    ? measureInfoObj[1][1]
                    : "0"
                  : "0";
              averageItemPerSaleTotal =
                measureInfoObj[2] != null &&
                measureInfoObj[2] != undefined &&
                measureInfoObj[2].length > 0
                  ? measureInfoObj[2][1] != null
                    ? measureInfoObj[2][1]
                    : "0"
                  : "0";

              averageSalePrevious =
                measureInfoObj[3] != null &&
                measureInfoObj[3] != undefined &&
                measureInfoObj[3].length > 0
                  ? measureInfoObj[3][1] != null
                    ? measureInfoObj[3][1]
                    : "0"
                  : "0";
              averageItemPerSalePrevious =
                measureInfoObj[4] != null &&
                measureInfoObj[4] != undefined &&
                measureInfoObj[4].length > 0
                  ? measureInfoObj[4][1] != null
                    ? measureInfoObj[4][1]
                    : "0"
                  : "0";

             // console.log("Revenue Total", totalValue1);
             // console.log("Revenue Previous", previousValue1);
            }
          } catch (e) {
            // message.error("AVERAGE sale Total Parsing Issue");
            averageSaleTotal = "0";
            averageSalePrevious = "0";
            averageItemPerSaleTotal = "0";
            averageItemPerSalePrevious = "0";
          }

          try {
            let currentChartInfo = JSON.parse(res.data.currentChartInfo);
            let currentXaxisInfo = JSON.parse(res.data.currentXaxisInfo);
            let previousXaxisInfo = JSON.parse(res.data.previousXaxisInfo);
            let previousChartInfo = JSON.parse(res.data.previousChartInfo);

            //console.log("currentXaxisInfo", currentXaxisInfo);
            //console.log("currentChartInfo", currentChartInfo);
            //console.log("previousXaxisInfo", previousXaxisInfo);
            //console.log("PreviousChartInfo", previousChartInfo);

            if (currentChartInfo != null) {
              if (currentChartInfo.length > 0) {
                lineChartsData = LineChartsJsonBuilder(
                  currentXaxisInfo,
                  currentChartInfo,
                  previousXaxisInfo,
                  previousChartInfo
                );
              }
            }
          } catch (e) {
            lineChartsData = [];
            // message.error("Current Line Charts Data Parsing Issue");
          }

          let sectionData = {
            TotalValue1: totalValue1
              ? parseFloat(totalValue1).toFixed(getDefaultDecimalPlaces) !=
                "NaN"
                ? parseFloat(totalValue1).toFixed(getDefaultDecimalPlaces)
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            PreviousValue1: previousValue1
              ? parseFloat(previousValue1).toFixed(getDefaultDecimalPlaces) !=
                "NaN"
                ? parseFloat(previousValue1).toFixed(getDefaultDecimalPlaces)
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            TotalValue2: totalValue2
              ? parseFloat(totalValue2).toFixed(getDefaultDecimalPlaces) !=
                "NaN"
                ? parseFloat(totalValue2).toFixed(getDefaultDecimalPlaces)
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            PreviousValue2: previousValue2
              ? parseFloat(previousValue2).toFixed(getDefaultDecimalPlaces) !=
                "NaN"
                ? parseFloat(previousValue2).toFixed(getDefaultDecimalPlaces)
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            LineChartsData: lineChartsData,
            AverageSaleValue: averageSaleTotal
              ? parseFloat(averageSaleTotal).toFixed(getDefaultDecimalPlaces) !=
                "NaN"
                ? parseFloat(averageSaleTotal).toFixed(getDefaultDecimalPlaces)
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            AverageSaleValuePrev: averageSalePrevious
              ? parseFloat(averageSalePrevious).toFixed(
                  getDefaultDecimalPlaces
                ) != "NaN"
                ? parseFloat(averageSalePrevious).toFixed(
                    getDefaultDecimalPlaces
                  )
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            AverageItemPerSaleValue: averageItemPerSaleTotal
              ? parseFloat(averageItemPerSaleTotal).toFixed(
                  getDefaultDecimalPlaces
                ) != "NaN"
                ? parseFloat(averageItemPerSaleTotal).toFixed(
                    getDefaultDecimalPlaces
                  )
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
            AverageItemPerSaleValuePrev: averageItemPerSalePrevious
              ? parseFloat(averageItemPerSalePrevious).toFixed(
                  getDefaultDecimalPlaces
                ) != "NaN"
                ? parseFloat(averageItemPerSalePrevious).toFixed(
                    getDefaultDecimalPlaces
                  )
                : parseFloat("0").toFixed(getDefaultDecimalPlaces)
              : parseFloat("0").toFixed(getDefaultDecimalPlaces),
          };
          setReportSectionData(sectionData);
          //console.log("Section Data ", sectionData);

          setLoader(false);
        }
      })
      .catch((e) => {
        // message.error("Something Went Wrong...");
      });
  }
  //#endregion API

  //#region Calculated Functions
  const LineChartsJsonBuilder = (
    periodData,
    lineData,
    previousPeriodData,
    previousLineData
  ) => {
    let lineChartsData = [];
    const LineChartsObj = Object.keys(lineData[0]).map((k) => lineData[0][k]);
    const PrevLineChartsObj = Object.keys(previousLineData[0]).map(
      (k) => previousLineData[0][k]
    );

    if (lineData.length > 0 && LineChartsObj && LineChartsObj.length > 0) {
      for (var i = 0; i < periodData.length; i++) {
        let PeriodDate = "";
        let PrevPeriodDate = "";
        let PeriodDateToolTip = "";
        let PrevPeriodDateToolTip = "";

        if (PeriodID == Period.Day) {
          PeriodDate = periodData[i].Value.split("(")[0]; // moment().format("ddd DD");
          PrevPeriodDate = previousPeriodData[i].Value.split("(")[0]; // moment(previousPeriodData[i].Value.split("(")[0]).format("ddd DD");
          PeriodDateToolTip = periodData[i].Value.split("(")[0] + " " + "Today"; // moment(periodData[i].Value.split("(")[0]).format("ddd DD");
          PrevPeriodDateToolTip =
            periodData[i].Value.split("(")[0] +
            "Last " +
            moment().format("dddd"); // moment(periodData[i].Value.split("(")[0]).format("ddd DD");

          setChartInterval(1);
        }
        if (PeriodID == Period.Week) {
          PeriodDate = moment(periodData[i].Value.split("(")[0]).format(
            "DD MMM"
          );
          PrevPeriodDate = moment(
            previousPeriodData[i].Value.split("(")[0]
          ).format("DD MMM");

          PeriodDateToolTip = `This ${moment(
            periodData[i].Value.split("(")[0]
          ).format("ddd")}`;
          PrevPeriodDateToolTip = `Last ${moment(
            periodData[i].Value.split("(")[0]
          ).format("ddd")}`;

          setChartInterval(2);
        }
        if (PeriodID == Period.Month) {
          PeriodDate = moment(periodData[i].Value.split("(")[0]).format(
            "DD MMM"
          );
          PrevPeriodDate = moment(
            previousPeriodData[i].Value.split("(")[0]
          ).format("DD MMM");

          PeriodDateToolTip = moment(periodData[i].Value.split("(")[0]).format(
            "ddd, DD MMM"
          );
          PrevPeriodDateToolTip = moment(
            previousPeriodData[i].Value.split("(")[0]
          ).format("ddd, DD MMM");

          setChartInterval(6);
        }

        let PeriodValue = 0;

        PeriodValue =
          LineChartsObj[i] && LineChartsObj[i] != null ? LineChartsObj[i] : "0";

        let PrevPeriodValue = 0;

        PrevPeriodValue =
          PrevLineChartsObj[i] && PrevLineChartsObj[i] != null
            ? PrevLineChartsObj[i]
            : "0";

        let lineObj = {
          PeriodDate: PeriodDate,
          PeriodDateToolTip: PeriodDateToolTip,
          PeriodValue: parseFloat(PeriodValue).toFixed(getDefaultDecimalPlaces),
          PreviousPeriodDate: PrevPeriodDate,
          PrevPeriodDateToolTip: PrevPeriodDateToolTip,
          PreviousPeriodValue: parseFloat(PrevPeriodValue).toFixed(
            getDefaultDecimalPlaces
          ),
        };
        lineChartsData.push(lineObj);
      }
    } else {
      let lineObj = {
        PeriodDate: "",
        PeriodValue: "",
        PreviousPeriodDate: "",
        PreviousPeriodValue: "",
      };
      lineChartsData.push(lineObj);
    }
    return lineChartsData;
  };
  function redirectToSalesReport(measureID, reportTypeID) {
    let fromFormatDate = moment().format("YYYY-MM-DDT00:00:00");
    let toFormatDate = moment().format("YYYY-MM-DDT23:59:00");
    let periodID = PeriodID;
    if (periodID == Period.Month) {
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
      fromFormatDate = moment(toFormatDate)
        .startOf("month")
        .format("YYYY-MM-DD");
    }

    if (periodID == Period.Week) {
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
      fromFormatDate = moment(toFormatDate)
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
    }

    if (periodID == Period.Day) {
      toFormatDate = moment(toFormatDate)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
      fromFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
    }
    let URL = `/dashboard/reporting/salesreports?definition={"ReportId":1,"ReportTypeId":${reportTypeID},"MeasureId":${measureID},"DateTimeFrom":"${fromFormatDate}","DateTimeTo":"${toFormatDate.toString()}","PeriodId":${periodID},"IsComparision":0,"ComparisionFrom":"","ComparisionTo":""}`;
    history.push(URL);
  }
  //#endregion

  //#region Components
  const TopSection = (props) => {
    return (
      <>
        {/* gx-pb-5 gx-pl-4 */}
        <div className="Graph-highlighter">
        <div className="GH-sub-txt">
          
          <h4
            className={`mb-0 ${
              props.totalValue1 <= 0 ? "dk-text-red" : "gx-text-black"
            } `}
          >
            {isCurrencyMeasure
              ? getCurrData.currencyCode != null
                ? getCurrData.currencyCode
                : getCurrData.currencyName != null
                ? getCurrData.currencyName
                : getCurrData.currencySymbol
              : ""}{" "}
            {formatDigits(props.totalValue1, getDefaultDecimalPlaces)}
          </h4>
          <p className="gx-text-grey">
            <IntlMessages id="dashboard.dashboardreporting.thats" />{" "}
            {props.currency}{" "}
            {formatDigits(props.previousValue1, getDefaultDecimalPlaces)}
            {props.previousValue1 < 0 ? (
              <IntlMessages id="dashboard.dashboardreporting.lessthanthistime" />
            ) : (
              <IntlMessages id="dashboard.dashboardreporting.morethanthis" />
            )}
            &nbsp; {props.periodName} !
          </p>
        </div>
        </div>
      </>
    );
  };
  const ChartSection = (props) => {
    return (
      <div className="D-Graph mb-4">
        <div className="gx-site-dash gx-mb-2 gx-pt-3 gx-pt-sm-0 gx-pt-xl-2">
          {!StringIsNullOrEmpty(chartTitle) ? (
            <h6 className="gx-text-uppercase gx-mb-2 gx-mb-sm-4">
              {chartTitle}
            </h6>
          ) : (
            ""
          )}
          <LineChart
            data={props.data}
            chartInterval={props.chartInterval}
            currency={props.currency}
          />
        </div>
      </div>
    );
  };
  const LeftSection = (props) => {
    return (
      <div className="Graph-highlighter">

        <h2>
          <IntlMessages id="dashboard.dashboardreporting.this" />{" "}
          {getPeriodName}{" "}
          <IntlMessages id="dashboard.dashboardreporting.yourstorehas" />
        </h2>

        <div className="GH-sub-txt">
          <h4 className="mb-0">
            {props.currency}&nbsp;
            {formatDigits(props.totalValue1, getDefaultDecimalPlaces)}
          </h4>
          <p className="gx-text-grey">
          <IntlMessages id="dashboard.dashboardreporting.thats" />{" "}
          {props.currency}{" "}
          {formatDigits(props.previousValue1, getDefaultDecimalPlaces)}{" "}
          {props.previousValue1 < 0 ? (
            <IntlMessages id="dashboard.dashboardreporting.lessthanthistime" />
          ) : (
            <IntlMessages id="dashboard.dashboardreporting.morethanthis" />
          )}
          &nbsp;{props.periodName} !
        </p>
        </div>
        
      </div>
    );
  };
  const ProgressiveBarSection = (props) => {
    return (
      <div className="div-flow">
        <h3 className="">
          <IntlMessages id="dashboard.dashboardreporting.yoursalestarget" />
        </h3>
        <Progress
          percent={(props.previousValue1 / props.totalValue1) * 100}
          format={(percent) => ``}
          strokeColor={"#0c4f8e"}
          status="active"
        />

        <div className="d-flex align-items-center justify-content-between">
          <h3 className="mb-0">
            {props.currency}{" "}
            {formatDigits(props.previousValue1, getDefaultDecimalPlaces)}
          </h3>
          <h3 className="mb-0">
            {props.currency}{" "}
            {formatDigits(props.totalValue1, getDefaultDecimalPlaces)}
          </h3>
        </div>

      </div>
    );
  };
  function DesignComponent({
    Design = "default",
    currency,
    totalValue1,
    previousValue1,
    totalValue2,
    previousValue2,
    chartInterval,
    linechartsData,
    averageSaleValue,
    averageSaleValuePrev,
    periodName,
    averageItemPerSaleValue,
    averageItemPerSaleValuePrev,
  }) {
    const myComponents = {
      FullWidth: (
        <FullWidthDesign
          currency={currency}
          totalValue1={totalValue1}
          previousValue1={previousValue1}
          chartInterval={chartInterval}
          linechartsData={linechartsData}
          averageSaleValue={averageSaleValue}
          averageSaleValuePrev={averageSaleValuePrev}
          periodName={periodName}
          averageItemPerSaleValue={averageItemPerSaleValue}
          averageItemPerSaleValuePrev={averageItemPerSaleValuePrev}
        />
      ),
      Compact: (
        <CompactDesign
          currency={currency}
          totalValue1={totalValue1}
          previousValue1={previousValue1}
          chartInterval={chartInterval}
          linechartsData={linechartsData}
          averageSaleValue={averageSaleValue}
          averageSaleValuePrev={averageSaleValuePrev}
          periodName={periodName}
          averageItemPerSaleValue={averageItemPerSaleValue}
          averageItemPerSaleValuePrev={averageItemPerSaleValuePrev}
        />
      ),
      MeasureDesign: (
        <MeasureDesign
          currency={currency}
          totalValue1={totalValue1}
          previousValue1={previousValue1}
          chartInterval={chartInterval}
          linechartsData={linechartsData}
          periodName={periodName}
        />
      ),
      LeftCompactDesign: (
        <LeftCompactDesign
          currency={currency}
          totalValue1={totalValue1}
          previousValue1={previousValue1}
          totalValue2={totalValue2}
          previousValue2={previousValue2}
          chartInterval={chartInterval}
          linechartsData={linechartsData}
          averageSaleValue={averageSaleValue}
          averageSaleValuePrev={averageSaleValuePrev}
          periodName={periodName}
          averageItemPerSaleValue={averageItemPerSaleValue}
          averageItemPerSaleValuePrev={averageItemPerSaleValuePrev}
        />
      ),
      default: <FullWidthDesign />,
    };
    return myComponents[Design];
  }
  const FullWidthDesign = ({
    currency,
    totalValue1,
    previousValue1,
    chartInterval,
    linechartsData,
    averageSaleValue,
    averageSaleValuePrev,
    periodName,
    averageItemPerSaleValue,
    averageItemPerSaleValuePrev,
  }) => {
    return (
      <div className='no-flex-div ssbox-content'>
        {/* Left Section */}
        {showProgressSection ? (
          <ProgressiveBarSection
            currency={currency}
            totalValue1={totalValue1}
            previousValue1={previousValue1}
          />
        ) : (
          <LeftSection
            currency={currency}
            totalValue1={totalValue1}
            previousValue1={previousValue1}
            periodName={periodName}
          />
        )}

        {/* Chart Section */}
        <ChartSection
          data={linechartsData}
          chartInterval={chartInterval}
          currency={currency}
        />

        {/* Right Section ; Measure Section  */}

        <div className="d-flex-cont align-items-center justify-content-between">

        <div className="Graph-highlighter float-left">
          <h2>{subHeading1}</h2>

          <div className="GH-sub-txt">
          <h4 className="mb-0">
{currency}{" "}
              {formatDigits(averageSaleValue, getDefaultDecimalPlaces)}
            </h4>
            <p className="gx-text-grey">
            {currency}{" "}
            {formatDigits(averageSaleValuePrev, getDefaultDecimalPlaces)}{" "}
            {averageSaleValuePrev < "0" ? (
              <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
            ) : (
              <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
            )}{" "}
            {periodName}.
          </p>
          </div>

          </div>

          <div className="Graph-highlighter float-left">

          <h2>{subHeading2}</h2>

          <div className="GH-sub-txt">
          <h4 className="mb-0">
              {formatDigits(averageItemPerSaleValue, getDefaultDecimalPlaces)}
            </h4>
            <p className="gx-text-grey">
            {averageItemPerSaleValuePrev}&nbsp;
            {averageItemPerSaleValuePrev < "0" ? (
              <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
            ) : (
              <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
            )}
            &nbsp;<span>{periodName}</span>.
          </p>
          </div>

          </div>

          </div>

          
        </div>



    );
  };
  const CompactDesign = ({
    currency,
    totalValue1,
    previousValue1,
    chartInterval,
    linechartsData,
    averageSaleValue,
    averageSaleValuePrev,
    periodName,
    averageItemPerSaleValue,
    averageItemPerSaleValuePrev,
  }) => {
    return (
      <div className='no-flex-div ssbox-content'>
        
          {/* Left Section */}
          {showProgressSection ? (
            <ProgressiveBarSection
              currency={currency}
              totalValue1={totalValue1}
              previousValue1={previousValue1}
            />
          ) : (
            <LeftSection
              currency={currency}
              totalValue1={totalValue1}
              previousValue1={previousValue1}
              periodName={periodName}
            />
          )}



          <div className="div-flow d-flex-cont align-items-center justify-content-between mb-3 mt-5">

            <div className="Graph-highlighter float-left">
              <h2> {" "} <IntlMessages id="dashboard.dashboardreporting.averagesalevalue" /> </h2>

              <div className="GH-sub-txt">

                <h4 className="mb-0">
                  {currency}{" "}
                  {formatDigits(averageSaleValue, getDefaultDecimalPlaces)}
                </h4>

                <p className="gx-text-grey">
                {currency}{" "}
                {formatDigits(averageSaleValuePrev, getDefaultDecimalPlaces)}
                {averageSaleValuePrev < "0" ? (
                  <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
                ) : (
                  <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
                )}{" "}
                {periodName}.
              </p>

              </div>

              
            </div>

            <div className="Graph-highlighter float-left">
              <h2>
                <IntlMessages id="dashboard.dashboardreporting.averageitemspersale" />
              </h2>


             <div className="GH-sub-txt">
             <h4 className="mb-0">
                  {formatDigits(
                    averageItemPerSaleValue,
                    getDefaultDecimalPlaces
                  )}
                </h4>
                <p className="gx-text-grey">
                {formatDigits(
                  averageItemPerSaleValuePrev,
                  getDefaultDecimalPlaces
                )}
                &nbsp;
                {averageItemPerSaleValuePrev < "0" ? (
                  <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
                ) : (
                  <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
                )}
                &nbsp;<span>{periodName}</span>
              </p>
              </div>
              
            </div>

          </div>

          <ChartSection
            data={linechartsData}
            chartInterval={chartInterval}
            currency={currency}
          />

      </div>
    );
  };
  const MeasureDesign = ({
    currency,
    totalValue1,
    previousValue1,
    chartInterval,
    linechartsData,
    periodName,
  }) => {
    return (
      <>
        <div className="gx-d-flex GrossProfit-Chart">
          <h3>{cardTitle}</h3>
        </div>
        
        <div className='no-flex-div'>
          <TopSection
            currency={currency}
            totalValue1={totalValue1}
            previousValue1={previousValue1}
            periodName={periodName}
          />
          <LineChart
            data={linechartsData}
            chartInterval={chartInterval}
            currency={currency}
          />
          <div
            onClick={() => {
              redirectToSalesReport(MeasureID, ReportTypeID);
            }}
          >
            <span className="gx-text-primary gx-pointer gx-text-uppercase gx-fs-sm">
              <IntlMessages id="reporting.retaildashboard.viewreport" />
            </span>
          </div>
        </div>
      </>
    );
  };
  const LeftCompactDesign = ({
    currency,
    totalValue1,
    previousValue1,
    totalValue2,
    previousValue2,
    chartInterval,
    linechartsData,
    averageSaleValue,
    averageSaleValuePrev,
    periodName,
    averageItemPerSaleValue,
    averageItemPerSaleValuePrev,
  }) => {
    return (
      <>
        <div className="no-flex-div ssbox-content Discounted-box">

          <h3>{cardTitle}</h3>

          <ChartSection data={linechartsData} chartInterval={chartInterval} currency={currency} />

          {/* Right Section ; Measure Section  */}

          <div className="d-flex-cont align-items-center justify-content-between">

            <div className="Graph-highlighter float-left">

            <h2>{subHeading1}</h2>

            <div className="GH-sub-txt">
              <h4 className="mb-0"> {currency} {formatDigits(totalValue1, getDefaultDecimalPlaces)} </h4>
              <p className="gx-text-grey">
              {currency} {formatDigits(previousValue1, getDefaultDecimalPlaces)}{" "}
              {previousValue1 < "0" ? (
                <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
              ) : (
                <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
              )}{" "}
              {periodName}.
            </p>
            </div>

            </div>

            
            <div className="Graph-highlighter float-left">
            <h2>{subHeading1}</h2>

            <div className="GH-sub-txt">
              <h4 className="mb-0"> {formatDigits(totalValue2, getDefaultDecimalPlaces)} </h4>
            <p className="gx-text-grey">
              {previousValue2}&nbsp;
              {previousValue2 < "0" ? (
                <IntlMessages id="dashboard.dashboardreporting.lessthanlast" />
              ) : (
                <IntlMessages id="dashboard.dashboardreporting.morethanlast" />
              )}
              &nbsp;<span>{periodName}</span>.
            </p>
            </div>

            </div>



          </div>

        

        </div>
      </>
    );
  };
  //#endregion Components

  return (
    <>
    <div className={`${parentClassName} Graph-card`}>    
    <div className="GrossProfit-Container">
      <Spin spinning={getLoader} size="large">
        <div className="gx-card div-flow">
          <div
            className={`gx-card-body ${
              design == "MeasureDesign" ? "" : ""
            }`}
          >
            <DesignComponent
              Design={design}
              currency={
                getCurrData.currencyCode != null
                  ? getCurrData.currencyCode
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencySymbol
              }
              totalValue1={getReportSectionData.TotalValue1}
              previousValue1={getReportSectionData.PreviousValue1}
              totalValue2={getReportSectionData.TotalValue2}
              previousValue2={getReportSectionData.PreviousValue2}
              periodName={getPeriodName}
              chartInterval={getChartInterval}
              linechartsData={getReportSectionData.LineChartsData}
              averageSaleValue={getReportSectionData.AverageSaleValue}
              averageSaleValuePrev={getReportSectionData.AverageSaleValuePrev}
              perioName={getPeriodName}
              averageItemPerSaleValue={
                getReportSectionData.AverageItemPerSaleValue
              }
              averageItemPerSaleValuePrev={
                getReportSectionData.AverageItemPerSaleValuePrev
              }
            />
          </div>
        </div>
      </Spin>
      </div>
      </div>
    </>
  );
};

export default PerformanceCardSection;
